var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20px/verified_300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.12433 12.6495L13.4192 8.3338L12.6532 7.5678L9.12433 11.1175L7.33747 9.33062L6.57147 10.0966L9.12433 12.6495ZM9.99933 17.5677C8.25254 17.1041 6.80195 16.0894 5.64758 14.5238C4.4932 12.9581 3.91602 11.2073 3.91602 9.2713V4.78895L9.99933 2.44922L16.0826 4.78895V9.2713C16.0826 11.2073 15.5055 12.9581 14.3511 14.5238C13.1967 16.0894 11.7461 17.1041 9.99933 17.5677ZM9.99933 16.438C11.4438 15.9901 12.6382 15.0942 13.5827 13.7505C14.5271 12.4067 14.9993 10.9137 14.9993 9.2713V5.5213L9.99933 3.61266L4.99933 5.5213V9.2713C4.99933 10.9137 5.47155 12.4067 6.41599 13.7505C7.36044 15.0942 8.55488 15.9901 9.99933 16.438Z",
    fill: "#009469"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verifiedIcon.e7d5e7f1e7cb728e0e5827c579593adc.svg";
export { ForwardRef as ReactComponent };